import { createSlice } from "@reduxjs/toolkit";
import * as actions from './api';

export const dashboardSlice = createSlice({
    name: "dashboard",
    initialState: {
        loading: false,
        error: null,
        program_count: 0,
        course_count: 0,
        lesson_count: 0,
        popup: false,
    },
    reducers: {
        dashboardRequested: (state, action) => {
            state.loading = true;
        },
        statReceived: (state, action) => {
            state.loading = false;
            state.programCount = action.payload.program_count;
            state.courseCount = action.payload.course_count;
            state.lessonCount = action.payload.lesson_count;
        },
        dashboardError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    }
});

const {
    dashboardRequested,
    statReceived,
    dashboardError
} = dashboardSlice.actions;

const getStat = () => (dispatch, getState) => {
    const accessToken = getState().auth.accessToken;
    dispatch(
        actions.apiCallBegan(
            {
                url: `/dashboard/stat`,
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + accessToken
                },
                onStart: dashboardRequested.type,
                onSuccess: statReceived.type,
                onError: dashboardError.type
            }
        )
    );
}

export { getStat };

export default dashboardSlice.reducer;

